import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "axios";

import { DOMAIN_AI } from "../domain";

export const ACTION_SEND_CHAT_MESSAGE = "SEND_CHAT_MESSAGE";

interface ChatMessage {
  text: string;
  isUser: boolean;
}

interface SendChatMessageRequest {
  prompt: string;
  fileId: string;
  conversationHistory: ChatMessage[];
}

interface SendChatMessageResponse {
  response?: string;
  error?: string;
}

const sendChatMessage = async (
  request: SendChatMessageRequest,
): Promise<SendChatMessageResponse> => {
  try {
    const lastTenMessages = request.conversationHistory.slice(-10);

    const requestData = {
      prompt: request.prompt,
      fileId: request.fileId,
      conversationHistory: lastTenMessages,
    };

    const response = await axios({
      method: "POST",
      url: "https://greenometer.app.n8n.cloud/webhook/5905ce10-f7cc-4e34-8cfe-19dbca75caab",
      headers: {
        "Content-Type": "application/json",
      },
      data: requestData,
    });

    return {
      response: response.data?.response || "No response received",
    };
  } catch (error) {
    console.error("Chat message request failed:", error);
    throw new Error(
      error instanceof Error ? error.message : "Unknown error occurred",
    );
  }
};

export const useSendChatMessage = (): UseMutationResult<
  SendChatMessageResponse,
  Error,
  SendChatMessageRequest
> => {
  return useMutation<SendChatMessageResponse, Error, SendChatMessageRequest>({
    mutationKey: [DOMAIN_AI, ACTION_SEND_CHAT_MESSAGE],
    mutationFn: sendChatMessage,
  });
};
